import {Directive, Input, HostBinding, HostListener, ElementRef} from '@angular/core';

@Directive({
    selector: '[lib-rc-image-fallback]'
})

export class RcImageFallbackDirective {

    private fallback = false;

    @Input() default: string;

    @HostListener('error')
    updateUrl() {
        if (!this.fallback) {
            this.fallback = true;
            this.el.nativeElement.src = this.default;
        }
    }

    constructor(private el: ElementRef) {
    }
}
